/**
 * Keuzekaarten "Losse fles" / "Sixpack" (README §5.3): zetten het aantal in
 * Horizons aantal-kiezer (component-quantity-selector.js) en volgen de stepper
 * als de klant die zelf gebruikt. Verder niets; de korting komt in de wagen van
 * de automatische korting, en het bedrag op de koopknop zet smokkelaar-prijsregel.js.
 */

import { ThemeEvents } from '@theme/events';

class SmokkelaarHoeveelheid extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#klik);
    this.#sectie?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#volg);
    // Na "terug" kan de browser een eerder aantal in de stepper hebben teruggezet.
    const waarde = Number(this.#kiezer?.querySelector('input[name="quantity"]')?.value);
    if (waarde > 1) this.#markeer(waarde);
  }

  disconnectedCallback() {
    this.#sectie?.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#volg);
  }

  get #sectie() {
    return this.closest('.shopify-section');
  }

  get #kiezer() {
    return this.#sectie?.querySelector('product-form-component quantity-selector-component');
  }

  #klik = (event) => {
    const knop = event.target.closest('[data-aantal]');
    const kiezer = this.#kiezer;
    if (!knop || !kiezer) return;
    kiezer.setValue(knop.dataset.aantal);
    kiezer.onQuantityChange();
    kiezer.updateButtonStates();
    this.#markeer(Number(knop.dataset.aantal));
  };

  #volg = (event) => {
    if (event.target.closest('product-form-component')) this.#markeer(event.detail.quantity);
  };

  #markeer(n) {
    this.querySelectorAll('[data-aantal]').forEach((k) =>
      k.setAttribute('aria-pressed', String(Number(k.dataset.aantal) === n))
    );
  }
}

if (!customElements.get('smokkelaar-hoeveelheid')) {
  customElements.define('smokkelaar-hoeveelheid', SmokkelaarHoeveelheid);
}
